import store from '../../../store';
import VPagination from '../../VPagination.vue';

export default {
    components: { VPagination },

    mixins: [],

    data() {
        return {
            fetchingOrders: false,
            orders: { data: [] },
            currentPage: 1,
            status: 'all',
            searchText: '',
        };
    },

    computed: {
        totalPage() {
            return Math.ceil(this.orders.total / 20);
        },
    },

    created() {
        this.fetchOrderlist();
    },

    methods: {
        hasAnyOption(product) {
            return product.options_count > 0;
        },

        hasNoOption(product) {
            return !this.hasAnyOption(product);
        },

        hasBaseImage(product) {
            return product.base_image.length !== 0;
        },

        baseImage(product) {
            if (this.hasBaseImage(product)) {
                return product.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/themes/ecommerce/public/images/image-placeholder.png`;
        },

        productUrl(product) {
            return route('products.show', product.slug);
        },

        orderUrl(id) {
            return route('account.orders.show', id);
        },

        optionValues(option) {
            let values = [];
            if (option.value) {
                values.push(option.value);
            } else {
                for (let value of option.values) {
                    values.push(value.label);
                }
            }

            return values.join(', ');
        },

        changeStatus(status) {
            this.status = status;
            this.fetchOrderlist();
        },

        search() {
            this.fetchOrderlist();
        },

        fetchOrderlist() {
            this.fetchingOrders = true;

            $.ajax({
                method: 'GET',
                url: route('account.orders.products.index', {
                    page: this.currentPage,
                    status: this.status,
                    search: this.searchText,
                }),
            }).then((response) => {
                this.orders = response;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingOrders = false;
            });
        },

        buyAgain(order) {
            let products = order.products.map(item => {
                let options = {};
                item.options.forEach(element => {
                    const optionValues = element.values.reduce((acc, curr) => {
                        const { option_id, id } = curr;
                        acc[option_id] = element.value ? element.value : id;
                        return acc;
                    }, {});
                  
                    options = { ...options, ...optionValues };
                });
                
                return {
                    product_id: item.product_id,
                    qty: item.qty,
                    options: options,
                };
            });

            $.ajax({
                method: 'POST',
                url: route('cart.items.buy_again', { products: products }),
            }).then((cart) => {
                store.updateCart(cart);

                window.location.href = '/cart';
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            });
        },
    },
};
